module.exports = __webpack_public_path__ + "static/media/Roboto.69eee0b4.woff2";